import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Stack, Typography } from '@mui/material';
import { AttachedFile } from '../../organisms';

const ChatMessageContent = (props) => {
  const { paths, title, body, obs, response } = props;
  const titleVariant = body || paths ? 'subtitle1' : 'body1';
  const {
    palette: {
      primary: { lightest }
    }
  } = useTheme();

  return (
    <Stack gap={2}>
      {title && <Typography variant={titleVariant}>{title}</Typography>}
      {paths && (
        <Stack>
          {paths.split(',').map((path, idx) => (
            <AttachedFile key={`file-${idx}`} path={path} idx={idx} />
          ))}
        </Stack>
      )}
      {body && <Typography component="pre">{body}</Typography>}
      {obs && <Typography color={response ? 'text.secondary' : lightest}>{obs}</Typography>}
    </Stack>
  );
};

ChatMessageContent.propTypes = {
  body: PropTypes.string,
  obs: PropTypes.string,
  paths: PropTypes.string,
  response: PropTypes.bool,
  title: PropTypes.string
};

export default ChatMessageContent;
